import * as Auth from "~/auth";
import * as autocomplete from "~/autocomplete";
import $ from "jquery";
import * as _ from "~/utils";
import UI from "~/ui";
import {gotoLogin} from "~/utils";
import {getApi, handleError} from "~/auth";
import * as validation from "~/utils/validation";
import {format} from "date-fns";
import Component from "~/components/Component";


class FormError {
    private domElement: HTMLElement;
    
    constructor(errorElement: HTMLElement) { 
        this.domElement = errorElement;
    }
    
    public showError(message: string) {
        $(this.domElement).html(message);
        $(this.domElement).removeClass("d-none"); 
        $(this.domElement).toggleClass("alert-success", false);
        $(this.domElement).toggleClass("alert-danger", true);
    }
    
    public showInfo(message: string) {
        $(this.domElement).html(message);
        $(this.domElement).removeClass("d-none");
        $(this.domElement).toggleClass("alert-danger", false);
        $(this.domElement).toggleClass("alert-success", true);
    }
    
    public hideError() {
        $(this.domElement).html("");
        $(this.domElement).addClass("d-none");
    }
}


export abstract class Form
{
    protected theForm: HTMLFormElement;
    protected  userInfo: Auth.UserInfo = {} as Auth.UserInfo;
    private _eventsRegistered: boolean = false;
    protected  errorMessage: FormError;
    private _onActivateFn: (() => Promise<void>) = async () => {};
    private _loaderFn: (() => Promise<void>) = async () => {};
    
    private _onSaveFn: () => Promise<void> = async () => {};
    
    protected constructor(formId: string) {
        this.theForm = document.getElementById(formId) as HTMLFormElement;
        if (!this.theForm) {
            throw new Error(`Form #${formId} non trovato`);
        }
        
        // Cerca l'elemento .error-message all'interno del form
        const errorElement = this.theForm.querySelector('.error-message') as HTMLElement;
        if (!errorElement) {
            throw new Error(`Elemento .error-message non trovato nel form #${formId}`);
        }
        
        this.errorMessage = new FormError(errorElement);
    }
    


    public abstract clear(): Promise<void>;

    public abstract bind(): Promise<void>;
    private async _bind(): Promise<void> {
        if (!this._eventsRegistered) {
            await this.bind();
            this._eventsRegistered = true;
        }
    }
    
    private async _unbind(): Promise<void> {
        await this.unbind();
        this._eventsRegistered = false;
    }
    public abstract unbind(): Promise<void>;


    public abstract fill(): Promise<void>;

    public abstract addValidation(): void;
    
    public useLoader(fn: () => Promise<void>) {
        this._loaderFn = fn;
    }
    
    public onActivate(fn: () => Promise<void>) {
        this._onActivateFn = fn;
    }
    
    public onSave(fn: () => Promise<void>) {
        this._onSaveFn = fn;
    }
    
    public async reload(): Promise<void> {
        this.errorMessage.hideError();
        await this.clear();
        await this.unbind();
        await this.bind();
        await this._wrapErrorHandling(async () => await this._loaderFn());
        await this.fill();
        this.addValidation();
        // NON chiamare handleSubmit() qui perché è già stato registrato in activate()
        // e non può essere rimosso senza tenere traccia del listener
    }
    
    protected async afterLoad(): Promise<void> {}
    public async activate(): Promise<void> {
        const that = this;
        
        // RESETTO TUTTI I CAMPI
        this.theForm.addEventListener('input', function (event) {
            that.theForm.classList.remove('was-validated');
        }, false);

        // INIZIALIZZO I CAMPi
        await this._wrapErrorHandling(async () => await this.bind());
        await this._wrapErrorHandling(async () => await this._onActivateFn());
        await this._wrapErrorHandling(async () => await this._loaderFn());
        
        await this.fill();
        this.addValidation();
        this.handleSubmit();
    }

    private async _wrapErrorHandling(fn: () => Promise<void>): Promise<void> {
        try {
            await fn();
        } catch (error) {
            this.errorMessage.showError(handleError(error));
        }
    }

    private handleSubmit() {
        if (this._eventsRegistered) return;

        this.theForm.addEventListener("submit", async event => {
            event.preventDefault();
            event.stopPropagation();

            this.onSubmitValidator();
            if (!this.theForm.checkValidity()) {
                this.theForm.classList.add('was-validated');
                return false;
            }
            
            try {
                await this._onSaveFn(); 
            } catch (error) {
                this.errorMessage.showError(handleError(error));
                return false;
            }
            
            return false;
        });
        
        // Imposta il flag per evitare di registrare il listener più volte
        this._eventsRegistered = true;
    }
    
    

    private onSubmitValidator: () => void = async () => {
    }
}